"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

const jsx_runtime_1 = require("react/jsx-runtime");

const SvgCloseCircled = props => (0, jsx_runtime_1.jsxs)("svg", Object.assign({
  "data-name": "Regular 1.5px/close_circled",
  xmlns: "http://www.w3.org/2000/svg",
  width: 20,
  height: 20
}, props, {
  children: [(0, jsx_runtime_1.jsx)("path", {
    "data-name": "Regular 1.5px/close_circled background",
    fill: "#fff",
    d: "M0 0h20v20H0z"
  }, void 0), (0, jsx_runtime_1.jsx)("path", {
    d: "M5.009 5.009a.744.744 0 000 1.052L8.948 10l-3.939 3.94a.744.744 0 001.052 1.051l3.94-3.938 3.939 3.938a.744.744 0 001.051-1.051L11.053 10l3.938-3.938a.744.744 0 00-1.051-1.053l-3.939 3.939-3.939-3.939a.744.744 0 00-1.053 0z",
    fill: "#999"
  }, void 0)]
}), void 0);

exports.default = SvgCloseCircled;